import styled from '@emotion/styled';
import { ReactSVG } from 'react-svg';

import type { SVGIconProps } from './SVGIcon.types';

const StyledReactSvg = styled(ReactSVG as any)<Pick<SVGIconProps, 'size'>>(({ size }) => ({
  display: 'inline-block',
  width: size || '1em',
  height: size || '1em',
  fill: 'currentcolor',
}));

export const S = {
  StyledReactSvg,
} as const;
